module.exports = __webpack_public_path__ + "img/construction_thumbnail-400x300.012c520c.jpg";